module.exports = __webpack_public_path__ + "img/hannah-masterclass.7fcc06d3.png";